__turbopack_context__.v({
  "container": "URenHW_container",
  "footerMeta": "URenHW_footerMeta",
  "footerRow": "URenHW_footerRow",
  "infoContainer": "URenHW_infoContainer",
  "leftFooterContainer": "URenHW_leftFooterContainer",
  "logoPlaceholder": "URenHW_logoPlaceholder",
  "outletAddress": "URenHW_outletAddress",
  "outletName": "URenHW_outletName",
  "topContainer": "URenHW_topContainer",
});
